import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { APP_NAME } from './shared/utilities/app-info';

/**
 * Sets the document title to "<Page> | SHIFTCLOCK AI".
 * Uses the route's `title` when present; otherwise falls back to the deepest
 * `data.title` (dashboard routes use translation keys there).
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title, private readonly translate: TranslateService) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot) ?? this.deepestDataTitle(snapshot.root);
    const translated = pageTitle ? this.translate.instant(pageTitle) : '';
    this.title.setTitle(translated ? `${translated} | ${APP_NAME}` : APP_NAME);
  }

  private deepestDataTitle(route: ActivatedRouteSnapshot): string | undefined {
    let current: ActivatedRouteSnapshot | null = route;
    let found: string | undefined;
    while (current) {
      if (current.data?.['title']) {
        found = current.data['title'];
      }
      current = current.firstChild;
    }
    return found;
  }
}
